import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import Equipment from "./Equipment";
import Inventory from "./Inventory";
import LocationDisplay from "./LocationDisplay";
import MessageLog from "./MessageLog";
import StatSheet from "./StatSheet";

import Combat from "../game/Combat";
import ItemChoiceModal from "./ItemChoiceModal";

class Game extends React.Component {
  constructor(props) {
    super();
    this.locations = props.locations;
    this.enemies = props.enemies;
    this.items = props.items;
    this.state = {
      hero: props.hero,
      enemy: props.enemies[0],
      location: props.locations[0],
      combat: new Combat(),
      log: [],
      nextDisabled: true,
      showItemChoiceModal: false,
      itemDropChoices: [],
      // add Next button state and disable after clicking
      // add Battle button state and disable while fighting
    };
    this.equipItem = this.equipItem.bind(this);
    this.travelToNext = this.travelToNext.bind(this);
    this.hideItemChoiceModal = this.hideItemChoiceModal.bind(this);
    this.addToInventory = this.addToInventory.bind(this);
  }

  createItemsListFromIds(itemIds) {
    let itemList = [];
    for (let id in itemIds) {
      let item = this.items.find(
        (e) => e.id === itemIds[id]
      )
      itemList.push(cloneDeep(item));
    }
    return itemList;
  }
  travelToNext() {
    if (!this.state.enemy.isDead()){ return; } // Maybe a log message for this odd case
    const loc = this.locations.find(
      (e) => e.id === this.state.location.id + 1
    );
    if (loc) {
      this.setState(
        {
          nextDisabled: true,
          location: cloneDeep(loc),
        },
        this.newEnemy // Lesson on callback function here
      );
    }
  }

  equipItem(invIndex) {
    let newHero = cloneDeep(this.state.hero);
    newHero.equipFromInventory(invIndex);
    this.setState({ hero: newHero });
  }

  addToInventory(item) {
    let newHero = cloneDeep(this.state.hero);
    newHero.addToInventory(cloneDeep(item));
    this.setState({ hero: newHero },this.hideItemChoiceModal);
  }

  battleStep() {
    if (this.state.hero.isDead() || this.state.enemy.isDead()) {
      return;
    }
    let newHero = cloneDeep(this.state.hero);
    let newEnemy = cloneDeep(this.state.enemy);
    let newCombat = cloneDeep(this.state.combat);
    let newItemDropChoices = cloneDeep(this.state.itemDropChoices);
    let newNextDisabled = this.state.nextDisabled;
    let newShowItemChoiceModal = this.state.showItemChoiceModal;

    let currentTurn = newCombat.nextTurn();
    if (currentTurn === 'player') {
      let enemyDamageTaken = newCombat.calculateDamage(newHero, newEnemy);
      newEnemy.hp.cur -= enemyDamageTaken;
      this.updateLog("Event", "You dealt ".concat(enemyDamageTaken));
    } else if (currentTurn === 'enemy') {
      let heroDamageTaken = newCombat.calculateDamage(newEnemy, newHero);
      newHero.hp.cur -= heroDamageTaken;
      this.updateLog("Event", "Enemy dealt ".concat(heroDamageTaken));
    } else {
      console.log("something went wrong");
      return;
    }

    if (newEnemy.isDead()) {
      newEnemy.hp.cur = 0;
      newNextDisabled = false;
      newCombat.resetTurnQueue();
      newItemDropChoices = [];
      if (this.state.location.lootTable.hasItems) {
        let itemIds = this.state.location.lootTable.dropDistinctItemsFromTable(3);
        newItemDropChoices = this.createItemsListFromIds(itemIds);
        newShowItemChoiceModal = true;
      }
    }
    if (newHero.isDead()) {
      newHero.hp.cur = 0;
    }

    this.setState({
      hero: newHero,
      enemy: newEnemy,
      combat: newCombat,
      nextDisabled: newNextDisabled,
      showItemChoiceModal: newShowItemChoiceModal,
      itemDropChoices: newItemDropChoices,
    });
    return;
  }
/*
  dropItem() {
    let itemId = this.state.location.dropItem();
    if (itemId) {
      let droppedItem = cloneDeep(this.items.find((e) => e.id === itemId));
      this.updateLog("Event", "You received ".concat(droppedItem.name));
      return droppedItem;
    }
    return null;
  }
*/
  updateLog(type, text) {
    const date = new Date();
    const time = date.toLocaleTimeString();
    const log = this.state.log;
    console.log(text);
    this.setState({
      log: log.concat([
        {
          type: type,
          text: text,
          time: time,
        },
      ]),
    });
    return;
  }

  newEnemy() {
    const enemyId = this.state.location.enemies[
      Math.floor(Math.random() * this.state.location.enemies.length)
    ];
    console.log(this.state.location);
    console.log(enemyId);

    const enemyCharacter = cloneDeep(
      this.enemies.find((e) => e.id === enemyId)
    );

    this.setState({
      enemy: enemyCharacter,
    });
  }

  hideItemChoiceModal(){
    console.log("hide modal");
    this.setState({
      showItemChoiceModal: false,
    })
  }

  render() {
    return (
      <Container fluid className="p-4">
        <Tabs defaultActiveKey="home">
          <Tab eventKey="home" title="Home">
            <Container fluid className="p-4">
              <Row>
                <Col xs={12} md={2} className="border p-3">
                  <LocationDisplay
                    location={this.state.location}
                    locations={this.props.locations}
                    travelToNext={this.travelToNext/*bound*/}
                    disabled={this.state.nextDisabled}
                  />
                  <Equipment equipment={this.state.hero.equipment} />
                  <h3> Quick Inventory </h3>
                  <Inventory
                    inventory={this.state.hero.inventory}
                    perRow={3}
                    equipItem={this.equipItem/*bound*/}
                  />
                </Col>
                <Col xs={12} md={8} className="border">
                  <Row className="p-4">
                    <Col className="border pr-4 py-2">
                      <StatSheet character={this.state.hero} />
                    </Col>
                    <Col className="border pl-4 py-2">
                      <StatSheet character={this.state.enemy} />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="border p-4">
                      <Button onClick={() => this.battleStep()}>Battle</Button>
                    </Col>
                    <Col className="border p-4">
                      <Button onClick={() => this.newEnemy()}>New Enemy</Button>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} md={2} className="border">
                  <MessageLog log={this.state.log} />
                </Col>
              </Row>
            </Container>
          </Tab>
          <Tab eventKey="inventory" title="Inventory">
            <Inventory
              inventory={this.state.hero.inventory}
              perRow={6}
              equipItem={this.equipItem /*bound*/}
            />
          </Tab>
          <Tab eventKey="skillTree" title="Skill Tree">
            Skill Tree
          </Tab>
        </Tabs>
        {/* put modal down here? */}
        <ItemChoiceModal
          showItemChoiceModal={this.state.showItemChoiceModal}
          hideItemChoiceModal={this.hideItemChoiceModal/*bound*/}
          addToInventory={this.addToInventory/*bound*/}
          choices={this.state.itemDropChoices}
        />
      </Container>
    );
  }
}

export default Game;
